import { PublicClientApplication } from '@azure/msal-browser';
import { msalConfig } from './authConfig';

/**
 * MSAL instance for Azure AD authentication
 * This is a singleton that should be initialized once before the app renders
 */
export const msalInstance = new PublicClientApplication(msalConfig);

/**
 * Clear all MSAL state from sessionStorage
 * Useful for recovering from stuck authentication states
 */
export const clearMsalState = (): void => {
  Object.keys(sessionStorage).forEach((key) => {
    if (key.startsWith('msal.')) {
      sessionStorage.removeItem(key);
    }
  });
};

/**
 * Initialize MSAL and handle any redirect responses
 * This must be called before rendering the React app
 * Handles errors gracefully - the app will render even if initialization fails
 */
export const initializeMsal = async (): Promise<void> => {
  try {
    await msalInstance.initialize();
    await msalInstance.handleRedirectPromise();
  } catch (error) {
    console.error('Failed to initialize MSAL:', error);

    // If there's an error during initialization (e.g., user cancelled login),
    // clear the interaction state so the user can try again
    if (
      error &&
      typeof error === 'object' &&
      'errorCode' in error &&
      (error.errorCode === 'user_cancelled' || error.errorCode === 'interaction_in_progress')
    ) {
      console.warn('Clearing stale interaction state');
      clearMsalState();
    }

    // Don't throw - let the app render anyway
  }
};
